import {StatementDefinition} from '@frontapp/workflows/commons';
import {macroActionTypes, macroConditionDefinitions} from '@frontapp/workflows/macros';
import {useMemo} from 'react';

import {ClientMacroDecisionTreeNodeStatement} from '../../../../../libs/shared/core/src/helpers/types/macroFlowBuilderTypes';
import {isDefined} from '../../../../../libs/shared/core/src/helpers/typescript/typeHelpers';
import {
  EditorStatementValidator,
  useEditorStatementValidator,
} from '../../../../settings/editors/commons/useEditorStatementValidator';
import {useRuleIntegrationContext} from '../../../../settings/rules/ruleIntegrationContext';

export type MacroFlowBuilderStatementValidator =
  EditorStatementValidator<ClientMacroDecisionTreeNodeStatement>;

export function useMacroFlowBuilderStatementValidator(): MacroFlowBuilderStatementValidator {
  const {ruleIntegration} = useRuleIntegrationContext();

  const {definitions, thirdPartyActionDefinitions} = useMemo(() => {
    // TODO(hugodelahousse 2024-06-13) Move definitions to integration manifest.
    const conditionDefinitions = macroConditionDefinitions;

    // TODO(hugodelahousse 2024-06-13) Move definitions to integration manifest.
    const actionDefinitions = Object.fromEntries(
      macroActionTypes
        .map((type) => {
          const definition = ruleIntegration.findActionDefinition({type, integration_id: 0});
          if (!definition) {
            return undefined;
          }
          return [
            type,
            {
              params: definition.parameters,
              ...definition,
            },
          ];
        })
        .filter(isDefined),
    );

    const thirdPartyDefinitions: Record<string, Record<string, StatementDefinition>> = {};
    for (const action of ruleIntegration.getIntegrationActionDefinitions()) {
      if (!thirdPartyDefinitions[action.defaultParams.integration_type_id]) {
        thirdPartyDefinitions[action.defaultParams.integration_type_id] = {};
      }

      thirdPartyDefinitions[action.defaultParams.integration_type_id][
        action.defaultParams.integration_action_type
      ] = {
        ...action,
        // @ts-expect-error TODO(hugodelahousse 2024-06-13) Unify definition types
        params: action.parameters,
      };
    }

    return {
      definitions: {
        ...conditionDefinitions,
        ...actionDefinitions,
      },
      thirdPartyActionDefinitions: thirdPartyDefinitions,
    };
  }, [ruleIntegration]);

  return useEditorStatementValidator(
    definitions,
    thirdPartyActionDefinitions,
    macroFlowBuilderStatementValidatorOptions,
  );
}

const macroFlowBuilderStatementValidatorOptions = {
  ignoreDefaultParamValue: true,
};
